import { render } from "./Detaily.vue?vue&type=template&id=bdd2eff6"
import script from "./Detaily.vue?vue&type=script&lang=js"
export * from "./Detaily.vue?vue&type=script&lang=js"

import "./Detaily.vue?vue&type=style&index=0&id=bdd2eff6&lang=scss"

import exportComponent from "F:\\Projeler\\vuejs\\eticposdashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__